import { GOOGLE_AUTOCOMPLETE_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export const getAutocompletePredictions = async ({ input, countries, }) => {
    try {
        const response = await Network.get(GOOGLE_AUTOCOMPLETE_ENDPOINT, {
            params: {
                input,
                countries: countries.join(','),
            },
        });
        return response.data?.predictions;
    }
    catch (err) {
        return [];
    }
};
